export type FlipbookTextAlignment = 'left' | 'center' | 'right'
export type FlipbookAnnotationStrokeTool = 'pen' | 'highlighter'

export const FLIPBOOK_ANNOTATION_SCHEMA_VERSION = 1 as const

export interface FlipbookNormalizedPoint {
  readonly x: number
  readonly y: number
}

export interface FlipbookAnnotationStroke {
  readonly id: string
  readonly layer: number
  readonly page: number
  readonly points: readonly FlipbookNormalizedPoint[]
  readonly tool: FlipbookAnnotationStrokeTool
  readonly color: string
}

export interface FlipbookTextAnnotation {
  readonly layer: number
  readonly id: string
  readonly page: number
  readonly text: string
  readonly align: FlipbookTextAlignment
  readonly color: string
  readonly x: number
  readonly y: number
  readonly width: number
  readonly height: number
}

export interface FlipbookAnnotationState {
  readonly strokesByPage: Record<number, readonly FlipbookAnnotationStroke[]>
  readonly textsByPage: Record<number, readonly FlipbookTextAnnotation[]>
}

export interface FlipbookAnnotationPage {
  readonly page: number
  readonly strokes: readonly FlipbookAnnotationStroke[]
  readonly texts: readonly FlipbookTextAnnotation[]
}

export const EMPTY_FLIPBOOK_ANNOTATION_STATE: FlipbookAnnotationState = {
  strokesByPage: {},
  textsByPage: {},
}

export interface FlipbookAnnotationHistoryControls {
  readonly canClear: boolean
  readonly canRedo: boolean
  readonly canUndo: boolean
  readonly alignSelectedText: (alignment: FlipbookTextAlignment) => void
  readonly bringSelectedForward: () => void
  readonly bringSelectedToFront: () => void
  readonly clear: () => void
  readonly deleteSelectedAnnotation: () => void
  readonly recolorSelectedStroke: (color: string) => void
  readonly recolorSelectedText: (color: string) => void
  readonly redo: () => void
  readonly sendSelectedBackward: () => void
  readonly sendSelectedToBack: () => void
  readonly selectedStrokeColor: string | null
  readonly selectedStrokeTool: 'pen' | 'highlighter' | null
  readonly selectedTextAlignment: FlipbookTextAlignment | null
  readonly selectedTextColor: string | null
  readonly undo: () => void
}

const noop = () => {}

export const EMPTY_FLIPBOOK_ANNOTATION_HISTORY: FlipbookAnnotationHistoryControls = {
  canClear: false,
  canRedo: false,
  canUndo: false,
  alignSelectedText: noop,
  bringSelectedForward: noop,
  bringSelectedToFront: noop,
  clear: noop,
  deleteSelectedAnnotation: noop,
  recolorSelectedStroke: noop,
  recolorSelectedText: noop,
  redo: noop,
  sendSelectedBackward: noop,
  sendSelectedToBack: noop,
  selectedStrokeColor: null,
  selectedStrokeTool: null,
  selectedTextAlignment: null,
  selectedTextColor: null,
  undo: noop,
}
